/**
 * Registers an action for a specific route.
 * @param routeIdentifier - Identifier of the route.
 * @param actionFunction - Action to be registered.
 */
export function setAction(routeIdentifier, actionFunction) {
    const sydlePaths = ['SYDLE', 'sydleApp'];
    sydlePaths.forEach((sydlePath) => {
        const SYDLE = window[sydlePath] || {};
        window[sydlePath] = SYDLE;
        if (!SYDLE.router) {
            SYDLE.router = {};
        }
        if (!SYDLE.router.actions) {
            SYDLE.router.actions = {};
        }
        let previousAction;
        if (SYDLE.router.actions[routeIdentifier]) {
            previousAction = SYDLE.router.actions[routeIdentifier];
        }
        SYDLE.router.actions[routeIdentifier] = async (context, commands) => {
            const previousActionReturnValue = await (previousAction === null || previousAction === void 0 ? void 0 : previousAction(context, commands));
            if (previousActionReturnValue) {
                return previousActionReturnValue;
            }
            return actionFunction(context, commands);
        };
    });
}
